import 'uni-pages';import 'uni-h5';import App from './App'
import uView from "uview-ui"
import i18n from "@/utils/i18n"
import VueLazyload from "vue-lazyload"
import store from './store' //引入vuex,把vuex定义成全局组件
import apis from '@/utils/index'; // 引入全局函数
import share from '@/utils/share' //微信小程序分享，以及全局过滤器
import Vue from 'vue'
import {previewSvga} from './components/PreviewSvga/initPreviewSvga'
import {previewVideo} from "@/components/PreviewVideo/initPreviewVideo";
import {previewPag} from "@/components/PreviewPag/initPreviewPag";
import {logoMsg} from "@/components/LogoMsg/initLogoMsg";
Vue.use(uView)
Vue.use(VueLazyload, {
  observer: true,
	preLoad: 1.3,
	attempt: 1
})


Vue.prototype.$store = store
Vue.prototype.$previewSvga = previewSvga
Vue.prototype.$previewVideo = previewVideo
Vue.prototype.$previewPag = previewPag
Vue.prototype.$logoMsg = logoMsg

for (let i in apis) {
	Vue.prototype['$_' + i] = apis[i];
}

Vue.mixin(share)

Vue.config.productionTip = false
App.mpType = 'app'
const app = new Vue({
	i18n,
	...App
})
app.$mount()